import {deepMerge} from './deep-merge';

/**
 * Deeply clone any kind of js objects
 */
export function deepClone<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item)) as unknown as T;
  }
  return deepMerge({}, obj) as T;
}
